import { createConsola, LogLevels } from "consola";

import { env } from "../config/env";

const LEVEL_MAP: Record<string, number> = {
  silent: -999,
  error: LogLevels.error,
  warn: LogLevels.warn,
  info: LogLevels.info,
  debug: LogLevels.debug,
  verbose: LogLevels.verbose,
};

const level = LEVEL_MAP[env.LOG_LEVEL] ?? LogLevels.warn;
const withStack = env.LOG_STACK_TRACE;
const stackDepth = env.LOG_STACK_DEPTH;

const logger = createConsola({ level });

if (withStack) {
  Error.stackTraceLimit = stackDepth;
  const captureStackTrace = (
    Error as { captureStackTrace?: (target: object, fn?: unknown) => void }
  ).captureStackTrace;
  const logMethods = [
    "fatal",
    "error",
    "warn",
    "log",
    "info",
    "success",
    "debug",
    "trace",
    "verbose",
  ] as const;
  for (const method of logMethods) {
    const original = logger[method].bind(logger) as (
      ...args: unknown[]
    ) => void;
    const wrapper = (...args: unknown[]) => {
      const err = new Error();
      err.name = "";
      err.message = "\n[stack]";
      captureStackTrace?.(err, wrapper);
      original(...args, err);
    };
    Object.defineProperty(logger, method, {
      value: wrapper,
      configurable: true,
      writable: true,
    });
  }
}

export default logger;
